import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ZoneItemDeviceComponent } from '../zone-item-device/zone-item-device.component';
import { DeviceDto } from '../../../../../api/gen';

@Component({
  selector: 'app-zone-list-devices',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    ZoneItemDeviceComponent
  ],
  templateUrl: './zone-list-devices.component.html',
  styleUrl: './zone-list-devices.component.scss'
})
export class ZoneListDevicesComponent {
  @Input() devices: DeviceDto[] | null | undefined = [];
  @Input() isLoading = false;

  hasDevices(): boolean {
    return Array.isArray(this.devices) && this.devices.length > 0;
  }

  getDeviceCount(): number {
    return this.devices?.length ?? 0;
  }
}

